<div class="season-sky" *ngIf="mark && mark !== 'none' && !reduced" [attr.data-mark]="mark" aria-hidden="true">
	<canvas #board *ngIf="mark === 'glass'"></canvas>
	<div class="season-sun" *ngIf="mark === 'sun'"></div>
	<span
		class="floater"
		*ngFor="let item of floaters"
		[style.left]="item.left"
		[style.animationDelay]="item.delay"
		[style.animationDuration]="item.duration"
		[style.width]="item.size"
		[style.height]="item.size"
		[style.--drift]="item.drift"
		[style.--spin]="item.spin">
		<svg *ngIf="mark === 'heart'" viewBox="0 0 24 24">
			<path d="M12 20s-7-4.4-7-9a4 4 0 0 1 7-2 4 4 0 0 1 7 2c0 4.6-7 9-7 9z" />
		</svg>
		<svg *ngIf="mark === 'snowflake'" viewBox="0 0 24 24">
			<path d="M12 2v20M4.5 6.5l15 11M19.5 6.5l-15 11M8 3.5l4 4 4-4M8 20.5l4-4 4 4" />
		</svg>
		<svg *ngIf="mark === 'pumpkin'" viewBox="0 0 24 24">
			<path d="M12 7c-3 0-5 2.6-5 6.2C7 16.6 9.2 19 12 19s5-2.4 5-5.8C17 9.6 15 7 12 7zM12 7V4M12 9v8" />
		</svg>
		<svg *ngIf="mark === 'cauldron'" viewBox="0 0 24 24">
			<circle cx="12" cy="12" r="7" />
		</svg>
		<svg *ngIf="mark === 'crown'" viewBox="0 0 24 24">
			<path d="M12 3l2.2 6.2L21 10l-5 3.6L17.5 21 12 17.2 6.5 21 8 13.6 3 10l6.8-.8z" />
		</svg>
		<svg *ngIf="mark === 'egg'" viewBox="0 0 24 24">
			<path d="M12 4c3 2 5 6 5 10a5 5 0 0 1-10 0c0-4 2-8 5-10z" />
		</svg>
		<svg *ngIf="mark === 'sun'" viewBox="0 0 24 24">
			<circle cx="12" cy="12" r="4" />
		</svg>
	</span>
</div>
